import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";

let index = () => import(/* webpackChunkName: "files" */ '@/views/files/Index');
let upload = () => import(/* webpackChunkName: "files" */ '@/views/files/Upload');
let edit = () => import(/* webpackChunkName: "files" */ '@/views/files/Edit');

export default [
    ...prefix("/files",[
        {
            path: "",
            name: "files.index",
            component: index,
            meta: {
                middleware: web,
                permissions: ['files:viewAny','files:viewSelfRecords'],
                title: "مدیریت فایل ها"
            }
        },
        {
            path: "upload",
            name: "files.upload",
            component: upload,
            meta: {
                middleware: web,
                permissions: ['files:upload'],
                title: " آپلود فایل  "
            }
        },
        {
            path: ":file",
            name: "files.edit",
            component: edit,
            meta: {
                middleware: web,
                permissions: ['files:updateAny','files:updateSelfRecords'],
                title: " ویرایش فایل  "
            }
        }
    ])
]